import * as B from '../../BountyDetailParts'

export const BountyDetailApproved = ({
  data,
  ...props
}: Omit<B.PageProps, 'children'>) => {
  return (
    <B.Page data={data} {...props}>
      <B.SparkCodes />
      <B.SectionGroup>
        <B.TitleRow />
        <B.StatusCard>
          <B.StatusHeading>Approved</B.StatusHeading>
          <B.StatusParagraph>Great work on your bounty!</B.StatusParagraph>
        </B.StatusCard>
        <B.LiveVideoPreview />
      </B.SectionGroup>
      <B.Earnings />
      <B.Feedback />
      <B.OrderDetails />
    </B.Page>
  )
}
